var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full preferencesPage"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"text-2xl my-3 font-semibold"},[_vm._v("Your selection")]),_c('preference-list')],1),_c('navbar',{attrs:{"hideSearch":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }